import angular from 'angular';

const providerModule = angular.module('tinaba.framework.providers.environment', [])
  .provider('Environment', function() {
    "ngInject";
    const environment = {};

    this.setEnvName = function(envName) {
      environment.envName = envName;
    };

    this.setEndPoints = function(endPoints) {
      environment.endPoints = endPoints;
    };

    this.setPushConfig = function(pushConfig) {
      // environment.pushConfig = pushConfig;
      environment.pushConfig = '';
    };

    this.setSocialConfig = function(socialConfig) {
      environment.socialConfig = socialConfig;
    };

    this.setFeedbackConfig = function(feedbackConfig) {
      environment.feedbackConfig = feedbackConfig;
    };

    this.setUiConfig = function(uiConfig) {
      environment.uiConfig = uiConfig;
    };

    this.setConstant = function(constantName, constantValue) {
      environment[constantName] = constantValue;
    };

    this.getEnvironment = function() {
      return angular.copy(environment);
    };

    this.$get = [function() {
      return angular.copy(environment);
    }];
  });

export default providerModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/EnvironmentProvider.js
 **/